// extracted by mini-css-extract-plugin
module.exports = {"content":"RecoverPasswordForm_content__3jzQe","form":"RecoverPasswordForm_form__1b6L3","input":"RecoverPasswordForm_input__1p8AE","action":"RecoverPasswordForm_action__pWRxa"};